import { createFileRoute } from "@tanstack/react-router";
import AdminEmailPage from "@/admin/pages/email";

export const Route = createFileRoute("/admin/email/")({
  component: AdminEmailPage,
});
